import { render, staticRenderFns } from "./MailTo.vue?vue&type=template&id=98f0cad2&"
import script from "./MailTo.vue?vue&type=script&lang=js&"
export * from "./MailTo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports